

import Vue from 'vue';
import Component from "vue-class-component";
import {BoListPanel, IOnOffHandlers} from "bonomo/dist";
import {Prop} from "vue-property-decorator";
import {BetterDataTableHeader} from "@/model/betterVuetifyInterfaces";
import {namespace} from "vuex-class";
import SimpleConfirmationDialog from "@/components/shared/SimpleConfirmationDialog.vue";
import {IContract} from '@/model/Contract/contractInterfaces'
import LockerSearch from "@/components/locker/widget/LockerSearch.vue";
import {ILocker} from "@/model/Locker/lockerInterfaces";
import {IErrors} from "@/model/IErrors";
import Datim from "@/components/shared/Datim.vue";
import CreateButton from "@/components/shared/CreateButton.vue";
import LockerNav from "@/components/locker/widget/LockerNav.vue";

const lockerModule = namespace("lockerModule");
const lockerContractModule = namespace("lockerContractModule");

@Component({
  components: {
    BoListPanel,
    CreateButton,
    Datim,
    LockerNav,
    LockerSearch,
    SimpleConfirmationDialog,
  }
})
export default class LockersContracts extends Vue {

  @Prop({default: 0})
  private lockerId!: number;

  @lockerModule.Getter('locker')
  private locker!: ILocker;
  // @todo @anyone we should actually use a fetchShortLocker because this loads all the hell - but we don't have that endpoint. However this works for now
  @lockerModule.Action('fetchLocker')
  private fetchLocker!: (lockerId: number) => void;

  @lockerContractModule.Getter('contracts')
  private contracts!: IContract[];
  @lockerContractModule.Action('fetchContracts')
  private fetchContracts!: (lockerId : any) => void;
  @lockerContractModule.Action('clearContracts')
  private clearContracts!: () => void;

  private subscribes: IOnOffHandlers = {};


  protected get panelTitle(): string {
    return ''+this.$t('contracts.contracts.title') + this.locker.name;

  }
  protected get headers(): BetterDataTableHeader[] {
    return [
      { text: this.$t('common.id'), align: 'start', value: 'id' },
      { text: this.$t('contracts.contract.fields.client_name.label'), align: 'start', value: 'client_name' },
      { text: this.$t('contracts.contract.fields.cost_center.label'), align: 'start',  value: 'cost_center' },
      { text: this.$t("contracts.contract.fields.locker_condition.label"), align: 'center',  value: 'locker_condition' },
      { text: this.$t('contracts.contract.fields.beginning_contract.label'), align: 'center',  value: 'beginning_contract' },
      { text: this.$t('common.createdAt'), align: 'center',  value: 'created' },
      { text: "", align: 'end', sortable: false, value: 'edit_action' },
    ];
  }

  created() {
    this.subscribes = this.$ons({
      'backend.call.KO.contractsLoaded': this.onLoadKO,
    });
    if (!this.locker || this.locker.id != this.lockerId) {
      this.fetchLocker(this.lockerId);
    }
  }

  beforeDestroy() {
    this.$offs(this.subscribes);
  }

  private editContract(id: any) {
    return this.$router.push({name: 'editContract', params: {contractId: id}})
  }
  private onLockerSelected(newLockerId: number) {
    this.$router.push({name: 'lockersContracts', params: {lockerId: '' + newLockerId}});
  }
  private getLockerContracts(filters: any) {
    filters.lockerId = +this.lockerId;
    this.fetchContracts(filters);
  }

  // turn back the hacker!
  private onLoadKO(errors: IErrors) {
    if (errors._[0] == ''+this.$t('errors.general._.401')) {
      this.$router.push({name: 'home'});
    }
  }

}

